// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/fn/string/includes' //IOS8
import 'core-js/fn/object/assign' //IOS8
import 'core-js/es6/symbol' //IOS8
import 'core-js/fn/symbol/iterator' //IOS8

import 'normalize.css'
import './share/rootStyle.styl'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import {init_gact} from './tools/mgtv/gact'
import get_param from './tools/param'

import {	URL_PARAMS, 
} from './store/mutation-types.js'
// import './EventBus/index'
import { setStore, removeStore, getStore } from './api/mUtils';
import { TICKET,OPENID, ACT_TICKET, ACT_SOURCE, ACT_ORDERID } from './constant/CookieKeys';
import { requestOpenId, wxOauth } from './api/pay';
import { setShare } from './tools/mgtv/share';
import { link } from 'fs';

Vue.config.productionTip = false
let source = get_param("source")
let ticket = get_param("ticket")
let order_id = get_param("order_id")
let urlParams = {
  source:source,
  ticket:ticket,
  order_id:order_id,
  code:get_param("code"),
  test_m:get_param("test_m"),
}

if(source!=null)
  setStore(ACT_SOURCE,source)
if(ticket!=null)
  setStore(ACT_TICKET,ticket)
if(order_id!=null)
  setStore(ACT_ORDERID,order_id)
if(getStore(ACT_SOURCE)=="null")//清除本地保存的有问题的source
{
  removeStore(ACT_SOURCE)
}
console.log("地址原始参数:",urlParams)
store.commit(URL_PARAMS,urlParams)
window.shareData = 
{
  title: '牛奶盒子太给力！充会员 送盒子 ！',
  desc: '充会员，送盒子！牛奶盒子首发献礼',
  img: 'https://club.mgtv.com/usercenter/static_niunai/img/wxfx.jpg',
  link:document.URL
}
// console.log("TICKET固定（测试），上线请删除")
// setStore(TICKET,"VVUW168XXIXHYDKB1537")//正式活动阶段固定（测试），上线请删除
// console.log("OPENID固定（测试），上线请删除")
// setStore(OPENID,"1FUW9821XFNAJUIMB622")
// console.log("移除本地OPENID，上线请删除")
// removeStore(OPENID)
// setStore(TICKET,"1FUW9821XFNAJUIMB622")
// setStore(TICKET,"ZJUW6427XYBUODSS3B5E")//正式


requestOpenId(urlParams.code)
init_gact();


console.log("pushState之前",document.URL)

const hash = window.location.hash!=""?window.location.hash.split("?")[0]:"";
history.pushState(null,null,`/usercenter/niunai.html`)
console.log("pushState之后 document.URL",document.URL)
console.log("数据收集")
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  console.log("路径路径",to) 
  if (hash.indexOf("#/Address")!=-1) { // 是去填写地址页
    console.log("参数参数",to.params.order_id)
   if (sessionStorage.getItem('asid')) { // 已跳转 
    console.log("路由-该去哪去哪")
    // history.pushState(null,null,`/usercenter/niunai.html`)
    next(); 
   } else { //跳填写地址页
    sessionStorage.setItem('asid','aaa')
    console.log("路由-跳转填写地址页")
    // history.pushState(null,null,`/usercenter/niunai.html`)
    
    next({ 
     name: 'Address', // 未登录则跳转至login页面 
    //  query: {redirect: to.fullPath} // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
     params:urlParams
     }); 
   } 
  } else if (to.matched.some(res => res.name=="OrderDetail"||res.name=="AddressConfirm")) { //是去其他页面的
    console.log("路由-是去购买页面的")
    // history.pushState(null,null,`/usercenter/niunai.html`)
   next(); 
  } 
  else{
    console.log("路由-是去其他页面的")
    next();
  }
 });
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js